import React, {useState} from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";

import {OrganisationId} from "common/types/organisation";
import {AggregatedWorkflowTest, TestSet} from "common/flowmaster/types/test";

interface Props {
  organisationId: OrganisationId;
  workflowTests: AggregatedWorkflowTest[];
  testsets: TestSet[];
  addTestSet: (name: string) => Promise<void>;
}

export default function Tests({workflowTests, testsets, addTestSet}: Props) {
  const [showNewTestSetDialog, setShowNewTestSetDialog] = useState(false);
  function showTestSetCreator() {
    setShowNewTestSetDialog(true);
  }
  async function addTestSetXXX(name: string) {
    await addTestSet(name);
    setShowNewTestSetDialog(false);
  }
  return (
    <div style={{padding: "0.5em"}}>
      <div style={{display: "flex", justifyContent: "space-between"}}>
        <h1>LLM Tests</h1>
        <span
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => showTestSetCreator()}
          >
            Add Test Set
          </Button>
        </span>
      </div>
      <TestSetsTable testsets={testsets} />
      <TestsTable workflowTests={workflowTests} />
      <TestSetCreator
        isOpen={showNewTestSetDialog}
        hide={() => setShowNewTestSetDialog(false)}
        addTestSet={addTestSetXXX}
      />
    </div>
  );
}

function TestSetsTable({testsets}: {testsets: TestSet[]}) {
  return (
    <table>
      <thead>
        <th>Name</th>
      </thead>
      <tbody>
        {testsets.map(testset => (
          <tr key={testset.id}>
            <td>{testset.name}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function TestsTable({
  workflowTests,
}: {
  workflowTests: AggregatedWorkflowTest[];
}) {
  return (
    <table>
      <thead>
        <th>Workflow</th>
        <th>Project</th>
        <th>Document</th>
        <th>Issue</th>
        <th>Last Generated</th>
        <th>State</th>
      </thead>
      <tbody>
        {workflowTests.map(test => (
          <tr key={test.id}>
            <td>{test.workflow_name}</td>
            <td>{test.project_name}</td>
            <td>{test.document_name}</td>
            <td>{test.issue_name}</td>
            <td>{test.llm_run_time}</td>
            <td>{test.all_pass ? "Pass" : "Fail"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

type TestSetCreatorProps = {
  isOpen: boolean;
  hide: () => void;
  addTestSet: (name: string) => void;
};
function TestSetCreator({isOpen, hide, addTestSet}: TestSetCreatorProps) {
  const [testSetName, setTestSetName] = useState("");
  return (
    <Dialog open={isOpen}>
      <DialogTitle id="alert-dialog-title">
        {"Use Google's location service?"}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="test-set-name"
          label="Test Set Name"
          fullWidth
          onChange={e => setTestSetName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => hide()} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => addTestSet(testSetName)}
          color="primary"
          disabled={testSetName.length === 0}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
